import { createRoot } from 'react-dom/client';
import { LiveApp } from './App';
import './styles.css';

export interface LiveBundleConfig {
  apiUrl?: string;
  sessionId?: string;
  /** Open in full player (also: ?fullscreen=true|1|yes). */
  fullscreen?: boolean;
}

function readFullscreenFlag(explicit?: boolean): boolean {
  if (explicit === true) return true;
  try {
    const raw = (new URLSearchParams(window.location.search).get('fullscreen') || '')
      .trim()
      .toLowerCase();
    return raw === '1' || raw === 'true' || raw === 'yes';
  } catch {
    return false;
  }
}

let mountedRoot: ReturnType<typeof createRoot> | null = null;

(window as any).IntanLiveCommerce = {
  init: (config: LiveBundleConfig = {}) => {
    // Auto-boot already mounts on load; skip duplicate theme init() calls.
    if (mountedRoot) return;

    const apiUrl =
      config.apiUrl ||
      document.querySelector('[data-intan-api-url]')?.getAttribute('data-intan-api-url') ||
      (document.querySelector('script[data-intan-api-url]') as HTMLScriptElement)?.dataset
        .intanApiUrl ||
      '';

    const sessionId =
      config.sessionId ||
      new URLSearchParams(window.location.search).get('session') ||
      document.querySelector('[data-intan-live-session]')?.getAttribute('data-intan-live-session') ||
      '';

    const fullscreen = readFullscreenFlag(config.fullscreen);

    if (!apiUrl) {
      console.error('IntanLiveCommerce: API URL is required');
      return;
    }

    let container = document.getElementById('intan-live-commerce');
    if (!container) {
      container = document.createElement('div');
      container.id = 'intan-live-commerce';
      document.body.appendChild(container);
    }

    mountedRoot = createRoot(container);
    mountedRoot.render(
      <LiveApp
        apiUrl={apiUrl.replace(/\/$/, '')}
        sessionId={sessionId || undefined}
        initialFullscreen={fullscreen}
      />
    );
  },
};

const boot = () => {
  if (document.querySelector('[data-intan-live-root], #intan-live-commerce, script[src*="intan-live-commerce"]')) {
    (window as any).IntanLiveCommerce.init();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
